export default function ({ app, redirect }) {
	app.$axios.onResponseError((error) => {
		// If the error is 401 Unauthorized, redirect to login
		if (error.response && error.response.status === 401) {
			// Only redirect if not already on login page
			if (app.context.route.path !== '/login') {
				console.warn('axios interceptor: 401 detected, redirecting to login');
				// Clear auth state
				app.$auth.logout().then(() => {
					redirect('/login');
				}).catch(() => {
					redirect('/login');
				});
			}
		}
	});
}
